// removed by extract-text-webpack-plugin
module.exports = {"accordion":"_3GVm-Y5D8r_aS-wGWnOmti","panel":"_1_XbRii4GcxkCuFr7BERNk","panel__label":"_3ljZIPsMCiglaOPgiEbiXC","panel__content":"_2vr6XXVB_XSc77caaHjwoF","panel__inner":"dhjPx-JSNKT3tmSs9mg5N","cfgList":"riKgaDJxbsEihZSiCv4Fq"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/Accordion.styl
// module id = 734
// module chunks = 0